import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
var jwt = require("jsonwebtoken")
    ;

export default function Login(props) {

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [text, setText] = useState('')

    var login = function () {
        console.log(email, password)
        fetch("https://playattitude.fr/login", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            },
            body: JSON.stringify({ email: email, password: password })
        })
            .then(res => res.json())
            .then(res => {
                console.log(jwt.decode(res))
                let decode = jwt.decode(res)
                if (decode && decode.role === 1) {
                    console.log(res)
                    if (res) {
                        localStorage.setItem('web_bm', res)
                        window.location.replace("/dashboard");
                    }

                }
                else setText(res.response)
            })
    }

    return (

        <div className="center">
            <h2>Login</h2>
            <form noValidate autoComplete="off">
                <div >
                    <TextField id="standard-basic" label="Email" value={email} onChange={(event) => setEmail(event.target.value)} />
                </div>
                <br />
                <div>
                    <TextField id="standard-basic" label="Password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} />

                </div>
                <br />
                <div>
                    <Button variant="contained" onClick={() => login()}>Se connecter</Button>

                </div>
            </form>
            <div> <span>{text}</span></div>
        </div>

    );
}